// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page[data-v-0075b10d]{background-color:#f8f8f8}.layout[data-v-0075b10d]{min-height:calc(100vh - 4.48rem);padding-top:1.66rem;position:relative}.layout.cart[data-v-0075b10d]{min-height:calc(100vh - 4.08rem);padding-top:1.26rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
